<template>
    <div class="bg-gray-300 overflow-y-auto px-8 lg:px-80 py-8 lg:py-16 flex flex-col justify-center items-center">
        
        <div
            class="receipt-paper flex flex-col text-base lg:text-xl justify-start text-center align-middle items-center w-full py-6 lg:py-12 px-4 lg:px-8 text-grey-darker shadow-lg">
            <img src="https://resource.pafcpic.net/assets/ga/papsi_icon.png" class="w-20">
            <h1 class="text-2xl lg:text-4xl mt-4 font-bold">Summary of Votes</h1>
            <div class="border-b-2 lg:border-b-4 border-dashed w-full my-4 lg:my-8"></div>
            <div class="flex flex-col justify-start items-start w-full px-4 lg:px-12 text-left">
                <p class="font-medium">Ballot Number: <span class="font-normal">{{ this.$store.state.start_vote.ballot_no }}</span></p>
                <p class="font-medium">Name: <span class="font-normal uppercase">{{ this.$store.state.election_otp.last_name }}, {{ this.$store.state.election_otp.first_name }} {{ this.$store.state.election_otp.middle_name }} {{ this.$store.state.election_otp.suffix }}</span></p>
                <p class="font-medium">Account Number: <span class="font-normal">{{ this.$store.state.election_otp.account_number }}</span></p>
                <p class="font-medium">Serial Number: <span class="font-normal">{{ this.$store.state.election_otp.serial_number }}</span></p>
                <p class="font-medium">Number of Votes: <span class="font-normal">{{ this.$store.state.start_vote.total_votes }}</span></p>
            </div>
            <div class="border-b-2 lg:border-b-4 border-dashed w-full my-4 lg:my-8"></div>
            <div class="flex flex-col justify-start items-start w-full px-4 lg:px-12">
                <p class="font-bold mb-3">I. Board of Directors</p>
                <p class="border-b-2 border-grey-darkest mb-2">Officer Category (3)</p>
                <div v-if="bodOfficerVotes.length">
                    <div v-for="(vote, index) in bodOfficerVotes" :key="vote.code" class="text-left flex">
                        <span class="flex-shrink-0 w-3 lg:w-6 mr-2">{{ index + 1 }}.</span>
                        <p class="flex-grow">{{ vote.name }}</p>
                    </div>
                </div>

                <div v-else>
                    <p>No votes selected.</p>
                </div>

                <p class="border-b-2 border-grey-darkest mb-2 mt-6">Enlisted Personnel Category (3)</p>
                <div v-if="bodEpVotes.length">
                    <div v-for="(vote, index) in bodEpVotes" :key="vote.code" class="text-left flex">
                        <span class="flex-shrink-0 w-3 lg:w-6 mr-2">{{ index + 1 }}.</span>
                        <p class="flex-grow">{{ vote.name }}</p>
                    </div>
                </div>

                <div v-else>
                    <p>No votes selected.</p>
                </div>

                <p class="border-b-2 border-grey-darkest mb-2 mt-6">Civilian Category (2)</p>
                <div v-if="bodCivilianVotes.length">
                    <div v-for="(vote, index) in bodCivilianVotes" :key="vote.code" class="text-left flex">
                        <span class="flex-shrink-0 w-3 lg:w-6 mr-2">{{ index + 1 }}.</span>
                        <p class="flex-grow">{{ vote.name }}</p>
                    </div>
                </div>

                <div v-else>
                    <p>No votes selected.</p>
                </div>

                <p class="font-bold mb-2 mt-6 lg:mt-12 text-left">II. Audit Committee</p>
                <div v-if="selectedVotes.audit.length">
                    <div v-for="(vote, index) in selectedVotes.audit" :key="vote.code" class="text-left flex">
                        <span class="flex-shrink-0 w-3 lg:w-6 mr-2">{{ index + 1 }}.</span>
                        <p class="flex-grow">{{ vote.name }}</p>
                    </div>
                </div>
                <div v-else>
                    <p>No votes selected.</p>
                </div>

                <p class="font-bold mb-2 mt-6 lg:mt-12">III. Election Committee</p>
                    <p class="border-b-2 border-grey-darkest mb-2">Civilian Category (1)</p>
                    <div v-if="selectedVotes.elecom.length">
                        <div v-for="(vote, index) in selectedVotes.elecom" :key="vote.code" class="text-left flex">
                            <span class="flex-shrink-0 w-3 lg:w-6 mr-2">{{ index + 1 }}.</span>
                            <p class="flex-grow">{{ vote.name }}</p>
                        </div>
                    </div>

                <div v-else>
                    <p>No votes selected.</p>
                </div>
            </div>
            <div class="border-b-2 lg:border-b-4 border-dashed w-full my-4 lg:my-8"></div>
            <div class="flex flex-col justify-start items-start w-full px-4 lg:px-12 text-grey-darker">
                <p class="font-normal text-left">You Voted On: <span class="font-medium">{{ formattedVoteDate }}</span></p>
                <p class="font-normal text-left">You Submitted On: <span class="font-medium">{{ formattedSubmitDate }}</span></p>
            </div>
                
            <div class="border-b-2 lg:border-b-4 border-dashed w-full my-4 lg:my-8"></div>
            <!-- <VueBarcode :value="String()" format="CODE128" style="width: 25rem;"></VueBarcode> -->
            <p class="text-xl lg:text-3xl">THANK YOU FOR VOTING!</p>
            <p class="italic text-base lg:text-xl text-grey-darker mt-3">Serving the AFP Since 1981</p>
        </div>        
        <ButtonControl variant="secondary" class="mt-6 lg:mt-12 text-white" button_text="Proceed" @click="confirmVotes"></ButtonControl>
    </div>


    <ModalControl v-show="rating_modal" v-bind:display="rating_modal" z_value="z-50" :default_width="'max-w-xl'"
      id='vote_modal' closable>
      <RatingControl @close="this.$router.push('/events')" />
    </ModalControl>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import mixin from '@/mixin';
// import VueBarcode from '@chenfengyuan/vue-barcode';
import RatingControl from '@/components/controls/RatingControl.vue';
import ButtonControl from '@/components/controls/ButtonControl.vue';
import ModalControl from '@/components/controls/ModalControl.vue';

export default {
    name: 'SummaryVotesView',
    mixins: [mixin],
    data() {
        return {
            rating_modal: false,
        }
    },
    components: {
        ButtonControl,
        ModalControl,
        RatingControl
        // VueBarcode
    },
    computed: {
        ...mapGetters(['getSelectedVotes']),
        ...mapState(['voter', 'vote_schedule', 'ballot']), 
        gaCandidates() {
            return this.$store.state.gaCandidates || { bod: [], elecom: [], audit: [] };
        },
        selectedVotesCodes() {
            return this.$store.state.selectedVotes;
        },
        selectedVotes() {
            const codes = this.selectedVotesCodes;
            const candidates = this.gaCandidates;
            return {
                bod: codes.bod.map(code =>
                    candidates.bod.find(c => c.code === code) || { code, name: 'Unknown', type: '', image: '' }
                ),
                elecom: codes.elecom.map(code =>
                    candidates.elecom.find(c => c.code === code) || { code, name: 'Unknown', type: '', image: '' }
                ),
                audit: codes.audit.map(code =>
                    candidates.audit.find(c => c.code === code) || { code, name: 'Unknown', type: '', image: '' }
                ),
            };
        },
        bodOfficerVotes() {
            return this.selectedVotes.bod.filter(v => v.type === 'OFFICER');
        },
        bodEpVotes() {
            return this.selectedVotes.bod.filter(v => v.type === 'ENLISTED PERSONNEL');
        },
        bodCivilianVotes() {
            return this.selectedVotes.bod.filter(v => v.type === 'CIVILIAN');
        },
        auditVotes() {
            return this.selectedVotes.audit;
        },
        elecomVotes() {
            return this.selectedVotes.elecom;
        },
        formattedVoteDate() {
                const date = new Date(this.$store.state.voted);
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const day = date.getDate().toString().padStart(2, '0');
                const year = date.getFullYear();
                const hours = date.getHours().toString().padStart(2, '0');
                const minutes = date.getMinutes().toString().padStart(2, '0');
                const seconds = date.getSeconds().toString().padStart(2, '0');
                
                return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
        },
        formattedSubmitDate() {
            const date = new Date(this.$store.state.submitted);
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const day = date.getDate().toString().padStart(2, '0');
                const year = date.getFullYear();
                const hours = date.getHours().toString().padStart(2, '0');
                const minutes = date.getMinutes().toString().padStart(2, '0');
                const seconds = date.getSeconds().toString().padStart(2, '0');
                
                return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
        }
    },
    methods: {
        confirmVotes() {
            this.rating_modal = true;
        }
    }
};
</script>

<style scoped>
.receipt-paper {
    background: white;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
    position: relative;
    width: 100%;
}

/* Top gray bar */
.receipt-paper::before {
    content: "";
    position: absolute;
    left: -5%;
    width: 110%;
    height: clamp(8px, 2vw, 16px);
    background: #6b6b6b;
    border-radius: 50px;
    top: -8px;
}

/* Bottom receipt tear effect */
.receipt-paper::after {
    content: "";
    position: absolute;
    left: 0;
    width: 100%;
    height: clamp(20px, 6vw, 40px);
    background: radial-gradient(circle at center, white 50%, transparent 50%);
    background-size: clamp(20px, 6vw, 40px) clamp(20px, 6vw, 40px);
    bottom: calc(clamp(20px, 6vw, 40px) * -0.5);
}
</style>
